import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const DistrictService = {
  getDistrict(obj) {
    return httpClient.post(endPoints.getDistrict, obj);
  },
  getAllDistrictByPagination(obj) {
    return httpClient.post(endPoints.getAllDistrictByPagination, obj);
  },
  getDistrictDetail(obj) {
    return httpClient.post(endPoints.getDistrictDetail, obj);
  },
  addDistrict(obj) {
    return httpClient.post(endPoints.addDistrict, obj);
  },
  updateDistrict(obj) {
    return httpClient.post(endPoints.updateDistrict, obj);
  },
  deleteDistrict(obj) {
    return httpClient.post(endPoints.deleteDistrict, obj);
  },
};

export default DistrictService;



// WEBPACK FOOTER //
// ./src/service/DistrictService.js